import {
  FETCH_API_KEYS_REQUEST,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_FAIL,
  CREATE_API_KEY_REQUEST,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_FAIL,
  REVOKE_API_KEY_REQUEST,
  REVOKE_API_KEY_SUCCESS,
  REVOKE_API_KEY_FAIL,
  CLEAR_NEWLY_CREATED_KEY,
} from '../../store/types';

const initialState = {
  loading: false,
  error: null,
  keys: [],
  newlyCreatedKey: null,
  createLoading: false,
  createError: null,
  revokeLoading: false,
  revokeError: null,
};

const apiKeyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_API_KEYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_API_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        keys: action.payload || [],
        error: null,
      };

    case FETCH_API_KEYS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_API_KEY_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: null,
      };

    case CREATE_API_KEY_SUCCESS:
      return {
        ...state,
        createLoading: false,
        keys: [action.payload, ...(state.keys || [])],
        newlyCreatedKey: action.payload,
        createError: null,
      };

    case CREATE_API_KEY_FAIL:
      return {
        ...state,
        createLoading: false,
        createError: action.payload,
      };

    case REVOKE_API_KEY_REQUEST:
      return {
        ...state,
        revokeLoading: true,
        revokeError: null,
      };

    case REVOKE_API_KEY_SUCCESS:
      return {
        ...state,
        revokeLoading: false,
        keys: (state.keys || []).map((k) =>
          k.id === action.payload ? { ...k, status: 'REVOKED' } : k
        ),
        revokeError: null,
      };

    case REVOKE_API_KEY_FAIL:
      return {
        ...state,
        revokeLoading: false,
        revokeError: action.payload,
      };

    case CLEAR_NEWLY_CREATED_KEY:
      return {
        ...state,
        newlyCreatedKey: null,
      };

    default:
      return state;
  }
};

export default apiKeyReducer;
